module.exports = __webpack_public_path__ + "img/12_up.c14b3a37.jpg";